import { Alert, Button, Group, List, Modal, Paper, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { useSession } from '../../controllers/session-context.jsx';
import { useBilling } from '../../controllers/use-billing.js';
import { ErrorNotice } from '../feedback/error-notice.jsx';

export function BillingDialogs() {
  const { upgradeOpened, setUpgradeOpened, cancelOpened, setCancelOpened, config } = useSession();
  const { checkout, cancel } = useBilling();
  return <>
    <Modal opened={upgradeOpened} onClose={() => setUpgradeOpened(false)} title="Upgrade Page Outil" size="lg" centered>
      <Stack>
        <Text c="dimmed">Explore more pages and keywords, and take your data with you.</Text>
        <List size="sm"><List.Item>Up to 25,000 pages and keywords per query</List.Item><List.Item>CSV exports with your country and device filters</List.Item><List.Item>Cancel your subscription at any time</List.Item></List>
        {!config.billingEnabled && <Alert color="yellow">Subscriptions are unavailable right now. Please check back soon.</Alert>}
        <ErrorNotice error={checkout.error} />
        <SimpleGrid cols={{ base: 1, sm: 2 }}>
          {[['month', 'Monthly', 'Choose monthly'], ['year', 'Yearly', 'Choose yearly']].map(([interval, label, button]) => <Paper key={interval} withBorder p="lg"><Stack>
            <Title order={3}>{label}</Title><Text size="sm" c="dimmed">Review the price and billing details securely on Stripe before subscribing.</Text>
            <Button disabled={!config.billingEnabled || checkout.isPending} loading={checkout.isPending && checkout.variables === interval} onClick={() => checkout.mutate(interval)}>{button}</Button>
          </Stack></Paper>)}
        </SimpleGrid>
      </Stack>
    </Modal>
    <Modal opened={cancelOpened} onClose={() => setCancelOpened(false)} title="Cancel subscription?" centered>
      <Stack><Text>You’ll return to the free plan with 10 pages and 20 keywords per query. Cancellation takes effect immediately.</Text>
        <ErrorNotice error={cancel.error} />
        <Group justify="flex-end"><Button variant="default" onClick={() => setCancelOpened(false)}>Keep subscription</Button><Button color="red" loading={cancel.isPending} onClick={() => cancel.mutate()}>Confirm cancellation</Button></Group>
      </Stack>
    </Modal>
  </>;
}
